import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import AV from 'leancloud-storage'
import { 
  ActionSheet, 
  Button, 
  Card,
  Cell,
  CellGroup,
  Checkbox,
  CheckboxGroup,
  Dialog,
  DropdownMenu,
  DropdownItem,
  Empty,
  Field,
  Form,
  Icon,
  List,
  NavBar,
  Popup,
  PullRefresh,
  Space,
  Loading,
  Overlay,
  Image,
  Switch,
  Tab,
  Tabs,
  Toast,
  Picker,
  Tabbar,
  TabbarItem
} from 'vant'

// 引入 Vant 样式
import 'vant/lib/index.css'

// 初始化 LeanCloud
AV.init({
  appId: process.env.VUE_APP_LEANCLOUD_APP_ID,
  appKey: process.env.VUE_APP_LEANCLOUD_APP_KEY,
  serverURL: process.env.VUE_APP_LEANCLOUD_SERVER_URL
})

const app = createApp(App)

// 注册 Vant 组件
const vantComponents = [
  ActionSheet, 
  Button, Card, Cell, CellGroup, Checkbox, CheckboxGroup,
  Dialog, DropdownMenu, DropdownItem, Empty, Field, Form, Icon, 
  List, NavBar, Popup, PullRefresh, Space, Loading, Overlay,
  Image, Switch, Tab, Tabs, Toast, Picker, Tabbar, TabbarItem
]

vantComponents.forEach(component => {
  app.use(component)
})

app.use(store)
app.use(router)
app.mount('#app') 